<template>
  <modal
    :name="modalName"
    height="auto"
    width="900"
    :scrollable="true"
    :clickToClose="false"
    @before-open="aoAbrir"
  >
    <CloseModal :close="cancelar" />
    <Loading :isActive="loading" />
    <div class="cashback-regra__corpo">
      <div class="cashback-regra__conteudo">
        <div class="cashback-regra-topo__cabecalho">
          <div class="cashback-regra-topo__icone">
            <fa-icon icon="wallet" />
          </div>
          <div>
            <h4 class="cashback-regra-topo__titulo">{{ regra.id ? regra.nome || `Regra #${regra.id}` : "Nova regra de cashback" }}</h4>
            <span class="cashback-regra-topo__subtitulo">
              {{ regra.id ? `Regra #${regra.id}` : "Configure quem ganha, quanto ganha e em quais condições" }}
            </span>
          </div>
        </div>

        <CAlert v-if="erro" color="warning" closeButton class="cashback-regra__erro" @update:show="erro = null">{{ erro }}</CAlert>

        <CTabs variant="tabs" class="nav-tabs-boxed" :activeTab.sync="abaAtiva">
          <CTab title="Informações">
            <StepInformacoes :item="regra" :canais="opcoes.canais" @alterar="alterar" />
          </CTab>
          <CTab :title="`Faixas (${regra.faixas.length})`">
            <StepFaixas :item="regra" :bases-valor="opcoes.basesValor" :comportamentos-teto="opcoes.comportamentosTeto" @alterar="alterar" />
          </CTab>
          <CTab :title="tituloRestricoes">
            <StepRestricoes :item="regra" :opcoes="opcoes" :valores="valoresPorTipo" :dimensoes="dimensoes" @alterar="alterar" />
          </CTab>
          <CTab title="Combinações e limites">
            <StepCombinacoesLimites :item="regra" :opcoes="opcoes" @alterar="alterar" />
          </CTab>
          <CTab title="Resumo">
            <StepResumo :item="regra" :opcoes="opcoes" :valores="valoresPorTipo" :dimensoes="dimensoes" />
          </CTab>
        </CTabs>
      </div>
    </div>
    <div class="cashback-regra__rodape">
      <CButton variant="outline" color="secondary" @click="cancelar">Cancelar</CButton>
      <CButton color="primary" :disabled="loading" @click="salvar">Salvar</CButton>
    </div>
  </modal>
</template>

<script>
import clone from "just-clone";
import { get, post, put } from "@/helpers/apiRequest";
import CloseModal from "@/components/CloseModal.vue";
import Loading from "@/components/Loading.vue";
import StepInformacoes from "./sections/StepInformacoes.vue";
import StepFaixas from "./sections/StepFaixas.vue";
import StepRestricoes from "./sections/StepRestricoes.vue";
import StepCombinacoesLimites from "./sections/StepCombinacoesLimites.vue";
import StepResumo from "./sections/StepResumo.vue";
import { payloadRegra, rotuloDimensao, semValidade, validarRegra } from "./helpers";
import { STATUS_VALIDACAO, mensagemErroApi } from "../helpers";

export default {
  name: "ModalRegraCashback",
  components: {
    CloseModal,
    Loading,
    StepInformacoes,
    StepFaixas,
    StepRestricoes,
    StepCombinacoesLimites,
    StepResumo,
  },

  props: {
    item: { type: Object, required: true },
    close: { type: Function, required: true },
  },

  data() {
    return {
      modalName: "ModalRegraCashback",
      loading: false,
      erro: null,
      abaAtiva: 0,
      regra: clone(this.item),
      opcoes: {
        canais: [],
        periodos: [],
        restricoesProduto: [],
        restricoesCliente: [],
        restricoesCondicao: [],
        basesComUso: [],
        basesValor: [],
        comportamentosTeto: [],
        valores: {},
        dimensoes: [],
      },
    };
  },

  computed: {
    tituloRestricoes() {
      const total = (this.regra.restricoes || []).length;

      return total ? `Restrições (${total})` : "Restrições";
    },

    valoresPorTipo() {
      const valores = this.opcoes.valores || {};

      return Object.keys(valores).reduce((mapa, tipo) => {
        mapa[tipo] = (valores[tipo] || []).map((opcao) => ({ id: opcao.chave, descricao: opcao.label }));

        return mapa;
      }, {});
    },

    dimensoes() {
      const lista = Array.isArray(this.opcoes.dimensoes) ? this.opcoes.dimensoes : this.opcoes.dimensoes?.data || [];

      return lista.map((dimensao) => ({
        coluna: dimensao.coluna,
        label: rotuloDimensao(dimensao.label),
        opcoes: (dimensao.dimensoes?.data || dimensao.dimensoes || []).map((opcao) => ({
          id: String(opcao.id),
          descricao: opcao.desc || opcao.descricao || String(opcao.id),
        })),
      }));
    },
  },

  watch: {
    item(novo) {
      this.regra = clone(novo);
    },
  },

  methods: {
    aoAbrir() {
      this.regra = clone(this.item);
      this.erro = null;
      this.abaAtiva = 0;
      this.loadOpcoes();
    },

    alterar(alteracao) {
      Object.keys(alteracao).forEach((campo) => this.$set(this.regra, campo, alteracao[campo]));
    },

    loadOpcoes() {
      this.loading = true;

      get("/admin/cashback/regras/opcoes")
        .then((json) => {
          this.opcoes = { ...this.opcoes, ...json };
        })
        .catch((err) => {
          this.erro = `Não foi possível carregar as opções da regra: ${err.message}`;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    cancelar() {
      this.close(false);
    },

    salvar() {
      const invalido = validarRegra(this.regra);

      if (invalido) {
        this.erro = invalido.mensagem;
        this.abaAtiva = invalido.aba;

        return;
      }

      this.erro = null;

      if (!semValidade(this.regra)) {
        return this.gravar();
      }

      return this.$swal({
        title: "Cashback sem prazo de validade",
        html: "<p>A validade está vazia ou com 0 dias. O cashback ganho por esta regra fica na carteira do cliente até ser usado e <b>não expira</b>.</p><p>Os avisos de vencimento não são enviados para esse saldo.</p>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Salvar sem prazo",
        cancelButtonText: "Revisar",
      }).then((res) => {
        if (res.value) {
          this.gravar();

          return;
        }

        this.abaAtiva = 3;
      });
    },

    gravar() {
      this.loading = true;
      const payload = payloadRegra(this.regra);
      const requisicao = this.regra.id ? put(`/admin/cashback/regras/${this.regra.id}`, payload) : post("/admin/cashback/regras", payload);

      return requisicao
        .then(() => this.close(true))
        .catch((err) => {
          if (err && err.apiStatus === STATUS_VALIDACAO) {
            this.erro = mensagemErroApi(err);

            return;
          }

          this.$swal({ title: "Não foi possível salvar", text: mensagemErroApi(err), icon: "error" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.cashback-regra-topo__cabecalho {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.cashback-regra-topo__icone {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background-color: var(--cashback-cor-primaria-suave);
  color: var(--cashback-cor-primaria);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.cashback-regra-topo__titulo {
  font-size: 18px;
  font-weight: 600;
  color: #1d2939;
  margin: 0;
}

.cashback-regra-topo__subtitulo {
  font-size: 12px;
  color: #667085;
}

.cashback-regra__corpo {
  padding: 32px;
}

.cashback-regra__corpo >>> .tab-content {
  max-height: calc(90vh - 200px);
  overflow-y: auto;
}

.cashback-regra__erro {
  white-space: pre-line;
}

.cashback-regra__rodape {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}
</style>
